__turbopack_context__.v({
  "downloadIcon": "styles-module-scss-module__qndnmq__downloadIcon",
  "downloadItem": "styles-module-scss-module__qndnmq__downloadItem",
  "downloadItemName": "styles-module-scss-module__qndnmq__downloadItemName",
  "expandedData": "styles-module-scss-module__qndnmq__expandedData",
  "expandedDescription": "styles-module-scss-module__qndnmq__expandedDescription",
  "statsTable": "styles-module-scss-module__qndnmq__statsTable",
  "tableWrapper": "styles-module-scss-module__qndnmq__tableWrapper",
});
